import { render } from "./ActionModal.vue?vue&type=template&id=6dd52ddc"
import script from "./ActionModal.vue?vue&type=script&lang=js"
export * from "./ActionModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__